import { BodyContent } from '../content'
import { Loading } from '../common'
import DebugJson from '../debug/DebugJson/DebugJson'
import useScript from './useScript'
import { ScriptItem } from '../../features/script/types'
import styles from './Script.module.scss'
import { getFilePath } from '../../shared/utils'
import { Copy, CopyContainer } from '../common/copy'
import { Typography } from '@mui/material'
import { InspectorContext } from '../content/ContentBlock/types/InspectorContent/InspectorContext'

const Script = () => {
  const { script, zoneId, completion, loading, error, debugP2 } = useScript()

  if (error) return <div>Error loading script: {error}</div>
  if (!script && !loading) return <div>No script data available.</div>

  return (
    <Loading loading={loading} fullscreen message="Loading script...">
      <div className={styles.scriptRoot}>
        {typeof completion === 'number' && (
          <CopyContainer padding="small">
            <Copy padding="large">
              <p>Completion: {Math.round(completion * 100)}%</p>
            </Copy>
          </CopyContainer>
        )}

        {script.map((scene: ScriptItem) => {
          const filePath = getFilePath({
            filePath: scene?.filePath,
            zoneId,
            sceneId: scene?.id,
          })
          return (
            <div key={scene.id} className={styles.scene}>
              <CopyContainer
                padding={{
                  right: 'xsmall',
                  left: 'large',
                  top: 'xsmall',
                  bottom: 'xsmall',
                }}
              >
                <CopyContainer padding={{ bottom: 'xsmall' }}>
                  <Copy stackSpacing="small">
                    {scene?.name ||
                      (scene.id && (
                        <Typography variant="h6" align="right">
                          {scene.name || scene.id}
                        </Typography>
                      ))}
                    {scene?.title && (
                      <Typography variant="h2">{scene.title}</Typography>
                    )}
                    {scene?.subTitle && (
                      <Typography variant="h4">{scene.title}</Typography>
                    )}
                  </Copy>
                </CopyContainer>
                {/* <CopyContainer padding={{ left: 'small' }}>
                  <Copy>
                    <Typography variant="h5">{scene.id}</Typography>
                    <Typography>sceneType: {scene?.sceneType}</Typography> 
                  </Copy>
                </CopyContainer> */}
              </CopyContainer>

              <InspectorContext.Provider value={{ disabled: true }}>
                <BodyContent
                  parentMeta={{
                    id: scene.id,
                    title: scene.title,
                  }}
                  filePath={filePath}
                  contentBlock={{
                    content: scene.content,
                    // size: 'small',
                  }}
                />
              </InspectorContext.Provider>
            </div>
          )
        })}

        {debugP2 && <DebugJson json={script} />}
      </div>
    </Loading>
  )
}

export default Script
